export default {
  title: "Contacts",
};
